import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import useBodyOverflowToggle from 'components/hooks/useBodyOverflowToggle';
import useEscapeKey from 'components/hooks/useEscapeKey';

import TextButton from 'components/application/buttons/TextButton';

export default function DownloadModal({
  actionButton,
  body,
  bodyIcon,
  header,
  isFailed,
  isOpen,
  onClose,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const handleWrapperClick = (event) => {
    if (event.target.classList.contains('popup__backdrop')) {
      onClose();
    }
  };

  useBodyOverflowToggle(isOpen);
  useEscapeKey(onClose, [isOpen]);

  return (
    <div
      className={classNames(
        'download_modal modal_report-retrieval',
        isOpen ? 'modalbox--open' : 'modalbox--close',
      )}
    >
      <div className='modalbox__scroller'>
        <div
          className='popup__backdrop tw-bg-grey-900 tw-opacity-75'
          onClick={handleWrapperClick}
        />
        <div className='modalbox__box-wrapper'>
          <div className='download_modal__content tw-border-grey-100 tw-bg-white'>
            <div className='download_modal__header tw-text-l tw-font-semibold tw-text-grey-900'>
              {header}
            </div>
            <div
              className={classNames(
                'download_modal__body tw-border-t-grey-100',
                isFailed && 'tw-text-red-600',
              )}
            >
              {bodyIcon}
              {body}
            </div>
            <div className='download_modal__footer tw-border-t-grey-100'>
              <TextButton
                className='tw-mr-3'
                color='blue'
                onClick={onClose}
                size='md'
              >
                {i18nTShared('cancel')}
              </TextButton>
              {actionButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

DownloadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
